import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { CaixaCirurgica } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  caixaCirurgica: boolean,
  editCaixaCirurgica: boolean,
}

@Module({ namespaced: true, name: 'SuporteCaixasCirurgicasStore' })
export default class SuporteCaixasCirurgicasStore extends VuexModule {
  public hospitalId: string = ''
  public searchCaixaCirurgica: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    caixaCirurgica: false,
    editCaixaCirurgica: false,
  }

  @Mutation
  setSearchCaixaCirurgica(val: string) {
    this.searchCaixaCirurgica = val
  }

  @Mutation
  clearSearchCaixaCirurgica() {
    this.searchCaixaCirurgica = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  /** Caixas cirúrgicas */
  private genericCaixasCirurgicasDefault: CaixaCirurgica[] = []
  public genericCaixasCirurgicas: CaixaCirurgica[] = [...this.genericCaixasCirurgicasDefault]
  private caixasCirurgicasDefault: CaixaCirurgica[] = []
  public caixasCirurgicas: CaixaCirurgica[] = [...this.caixasCirurgicasDefault]

  private caixaCirurgicaDefault: CaixaCirurgica = {
    id: '',
    caixaCirurgicaId: '',
    descricao: '',
    hisId: '',
    hospitalId: '',
    status: 'Ativo',
  }

  public caixaCirurgica: CaixaCirurgica = { ...this.caixaCirurgicaDefault }

  @Mutation
  setGenericCaixasCirurgicas(genericCaixasCirurgicas: CaixaCirurgica[]) {
    this.genericCaixasCirurgicas = genericCaixasCirurgicas
  }

  @Mutation
  clearGenericCaixasCirurgicas() {
    this.genericCaixasCirurgicas = [...this.genericCaixasCirurgicasDefault]
  }

  @Mutation
  setCaixasCirurgicas(caixasCirurgicas: CaixaCirurgica[]) {
    this.caixasCirurgicas = caixasCirurgicas
  }

  @Mutation
  clearCaixasCirurgicas() {
    this.caixasCirurgicas = [...this.caixasCirurgicasDefault]
  }

  @Mutation
  setCaixaCirurgica(caixaCirurgica: CaixaCirurgica) {
    this.caixaCirurgica = caixaCirurgica
  }

  @Mutation
  clearCaixaCirurgica() {
    this.caixaCirurgica = { ...this.caixaCirurgicaDefault }
  }

  @Action
  async getGenericCaixasCirurgicas() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllCaixasCirurgicas()
      if (request.success) this.context.commit('setGenericCaixasCirurgicas', request.data as CaixaCirurgica[] || [])
      return request
    } catch (error) {
      this.context.commit('setGenericCaixasCirurgicas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getCaixasCirurgicas(hospitalId: string) {
    try {
      const params: any = { hospitalId, searchText: this.searchCaixaCirurgica }
      const request = await Apis.Agendamento.SuporteApi.getAllCaixasCirurgicasByHospitalId(params)
      if (request.success) this.context.commit('setCaixasCirurgicas', request.data as CaixaCirurgica[] || [])
      return request
    } catch (error) {
      this.context.commit('setCaixasCirurgicas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async postCaixaCirurgicaToHospital(caixaCirurgica: any) {
    try {
      const params: any = { hospitalId: this.hospitalId, ...caixaCirurgica }
      const request = await Apis.Agendamento.SuporteApi.postCaixaCirurgicaToHospital(params)
      if (request.success) this.context.dispatch('getCaixasCirurgicas', this.hospitalId)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async putCaixaCirurgicaToHospital() {
    try {
      const params: any = { hospitalId: this.hospitalId, ...this.caixaCirurgica }
      const request = await Apis.Agendamento.SuporteApi.putCaixaCirurgicaToHospital(params)
      if (request.success) this.context.dispatch('getCaixasCirurgicas', this.hospitalId)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
